import React from 'react';
import { motion } from 'framer-motion';
import { UserX, Clock, Shield, TrendingDown } from 'lucide-react';
import { Card } from '../../ui/card';

const iconMap = {
  UserX,
  Clock,
  Shield,
  TrendingDown,
};

const ProblemSlide = ({ data }) => {
  return (
    <div className="w-full max-w-6xl mx-auto">
      {/* Header */}
      <motion.div
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        className="text-center mb-12"
      >
        <h2 className="text-5xl md:text-6xl font-bold text-white mb-4">{data.title}</h2>
        <p className="text-xl text-slate-400">{data.subtitle}</p>
      </motion.div>

      {/* Problem Cards */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {data.points.map((point, index) => {
          const Icon = iconMap[point.icon];
          return (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.2 + index * 0.1 }}
            >
              <Card className="bg-slate-800/50 border-red-500/20 p-6 h-full hover:border-red-500/40 transition-colors">
                <div className="flex items-start gap-4">
                  <div className="p-3 bg-red-500/10 rounded-xl shrink-0">
                    <Icon className="w-6 h-6 text-red-400" />
                  </div>
                  <div>
                    <h3 className="text-xl font-semibold text-white mb-2">{point.title}</h3>
                    <p className="text-slate-400 leading-relaxed">{point.description}</p>
                  </div>
                </div>
              </Card>
            </motion.div>
          );
        })}
      </div>
    </div>
  );
};

export default ProblemSlide;
